module.exports = __webpack_public_path__ + "static/media/profile-4.8b79b915.jpeg";